'use strict'
exports.__esModule = true
exports.set = set

/**
 * Дублирует функционал Date.setUTC*
 *
 *
 * @param {Date} d
 * @param {PartNameType} partName
 * @param {...number[]} args
 * @example
 * set( date, 'h', 23 ) // undefined
 * set( date, 'm', 59 )
 * @memberof Time
 */
function set(d, partName) {
  for (
    var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2;
    _key < _len;
    _key++
  ) {
    args[_key - 2] = arguments[_key]
  }
  switch (partName) {
    case 'y':
      d.setUTCFullYear.apply(d, args)
      break
    case 'M':
      d.setUTCMonth.apply(d, args)
      break
    case 'd':
      d.setUTCDate.apply(d, args)
      break
    case 'h':
      d.setUTCHours.apply(d, args)
      break
    case 'm':
      d.setUTCMinutes.apply(d, args)
      break
    case 's':
      d.setUTCSeconds.apply(d, args)
      break
    case 'ms':
      d.setUTCMilliseconds.apply(d, args)
      break
    default:
      throw new Error('unknown time part name: ' + partName)
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/setters.js
// module id = 123
// module chunks = 0